export const Data = {

        bukalapak: {
            current : 45.85,
            prev: 55.78
        },
        tokopedia: {
            current : 72.85,
            prev: 79.78
        },
        shoopee: {
            current : 56.88,
            prev: 45.67
        },
}